// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestOperationId } from './HarvestOperation';
import { operatorId } from './Operator';
import { harvestOperationTemplateAttributeId } from './HarvestOperationTemplateAttribute';
import { invItemId } from './InvItem';
import { fileStorageId } from './FileStorage';
import { z } from 'zod';
export const harvestOperationAttributeId = (z.number());
export const harvestOperationAttribute = z.object({
    id: harvestOperationAttributeId,
    harvest_operation_id: harvestOperationId,
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    template_attribute_id: harvestOperationTemplateAttributeId,
    number_value: z.string().nullable(),
    measurement_unit: z.string().nullable(),
    check_value: z.boolean().nullable(),
    timestamp_value: z.date().nullable(),
    text_value: z.string().nullable(),
    inventory_item_id: invItemId.nullable(),
    media_attachment_file_storage_id: fileStorageId.nullable(),
    note: z.string().nullable(),
    computed_number: z.string().nullable(),
    computed_number_unit: z.string().nullable(),
    computed_number_status: z.string().nullable(),
    computed_number_eval_error: z.unknown().nullable(),
    cp_number_target: z.string().nullable(),
    cp_number_abs_tol_lower: z.string().nullable(),
    cp_number_abs_tol_upper: z.string().nullable(),
    cp_number_rel_tol_lower: z.string().nullable(),
    cp_number_rel_tol_upper: z.string().nullable(),
    cp_number_unit: z.string().nullable(),
    cp_check_value: z.boolean().nullable(),
});
export const harvestOperationAttributeInitializer = z.object({
    id: harvestOperationAttributeId.optional(),
    harvest_operation_id: harvestOperationId,
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    template_attribute_id: harvestOperationTemplateAttributeId,
    number_value: z.string().optional().nullable(),
    measurement_unit: z.string().optional().nullable(),
    check_value: z.boolean().optional().nullable(),
    timestamp_value: z.date().optional().nullable(),
    text_value: z.string().optional().nullable(),
    inventory_item_id: invItemId.optional().nullable(),
    media_attachment_file_storage_id: fileStorageId.optional().nullable(),
    note: z.string().optional().nullable(),
    computed_number: z.string().optional().nullable(),
    computed_number_unit: z.string().optional().nullable(),
    computed_number_status: z.string().optional().nullable(),
    computed_number_eval_error: z.unknown().optional().nullable(),
    cp_number_target: z.string().optional().nullable(),
    cp_number_abs_tol_lower: z.string().optional().nullable(),
    cp_number_abs_tol_upper: z.string().optional().nullable(),
    cp_number_rel_tol_lower: z.string().optional().nullable(),
    cp_number_rel_tol_upper: z.string().optional().nullable(),
    cp_number_unit: z.string().optional().nullable(),
    cp_check_value: z.boolean().optional().nullable(),
});
export const harvestOperationAttributeMutator = z.object({
    id: harvestOperationAttributeId.optional(),
    harvest_operation_id: harvestOperationId.optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    template_attribute_id: harvestOperationTemplateAttributeId.optional(),
    number_value: z.string().optional().nullable(),
    measurement_unit: z.string().optional().nullable(),
    check_value: z.boolean().optional().nullable(),
    timestamp_value: z.date().optional().nullable(),
    text_value: z.string().optional().nullable(),
    inventory_item_id: invItemId.optional().nullable(),
    media_attachment_file_storage_id: fileStorageId.optional().nullable(),
    note: z.string().optional().nullable(),
    computed_number: z.string().optional().nullable(),
    computed_number_unit: z.string().optional().nullable(),
    computed_number_status: z.string().optional().nullable(),
    computed_number_eval_error: z.unknown().optional().nullable(),
    cp_number_target: z.string().optional().nullable(),
    cp_number_abs_tol_lower: z.string().optional().nullable(),
    cp_number_abs_tol_upper: z.string().optional().nullable(),
    cp_number_rel_tol_lower: z.string().optional().nullable(),
    cp_number_rel_tol_upper: z.string().optional().nullable(),
    cp_number_unit: z.string().optional().nullable(),
    cp_check_value: z.boolean().optional().nullable(),
});
//# sourceMappingURL=HarvestOperationAttribute.js.map